import React, { useState } from "react";
import { Button, Modal } from "react-bootstrap";
import { toast } from "react-toastify";
import VendorExecutiveServices from "../../../services/API/VendorExecutive";
import FieldExecutiveServices from "../../../services/API/FieldExecutive";

// Activate / deactivate confirmation for the Alliance Manager executive / field executive lists.
// item: { row, rowNo } of the clicked record; reason is required for the status change log.
const StatusChangeModal = ({ item, isFE, onClose, onSuccess }) => {
  const [reason, setReason] = useState("");
  const [loading, setLoading] = useState(false);
  const label = isFE ? "Field Executive" : "Executive";
  const isActive = item?.row?.is_enabled == 1;

  const close = () => {
    setReason("");
    onClose();
  };

  const changeStatus = async () => {
    setLoading(true);
    // Same payloads the vendor list pages send to these endpoints
    const resp = isFE
      ? await FieldExecutiveServices.updatesFEStatus(item.row.id, {
          status: isActive ? 0 : 1,
          menu: "Field Executive List",
          reason,
          row_no: item.rowNo,
        })
      : await VendorExecutiveServices.deactivateExecutive(item.row.id, {
          status: !isActive,
          menu: "Executive List",
          reason,
          row_no: item.rowNo,
        });
    setLoading(false);
    if (resp) {
      toast.success(
        `${label} ${isActive ? "Deactivated" : "Activated"} Successfully`
      );
      close();
      onSuccess();
    }
  };

  return (
    <Modal show={!!item} onHide={close} animation={false} centered>
      <Modal.Header closeButton>
        <Modal.Title>Are you Sure?</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <p>
          You want to {isActive ? "Deactivate" : "Activate"} this {label}?
        </p>
        <label htmlFor="status-reason" className="mb-1">
          Reason <span className="text-danger">*</span>
        </label>
        <textarea
          id="status-reason"
          className="form-control mb-3"
          placeholder="Reason"
          value={reason}
          onChange={(e) => setReason(e.target.value)}
          maxLength={500}
        />
        <div className="d-flex gap-3 justify-content-end">
          <Button
            variant="danger"
            className="px-3 py-2"
            onClick={close}
            disabled={loading}
          >
            No
          </Button>
          <Button
            variant="success"
            className="px-3 py-2"
            onClick={changeStatus}
            disabled={loading || !reason.trim()}
          >
            {loading ? "Loading..." : "Yes"}
          </Button>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default StatusChangeModal;
